import { BaseApiService } from '@/services/base-service';
import { DataPilot, Filters } from '@/modules/data-pilot/types';

export class DataPilotService extends BaseApiService {
  private readonly base_path = 'data-pilot';

  async get_filters(): Promise<any> {
    const { data } = await this.http_client.get(`${this.base_path}/get-filters`);

    return data;
  }

  async get_client_events(filters: any): Promise<any> {
    const payload = filters;

    const { data } = await this.http_client.get(`${this.base_path}/event-list`, {
      params: {
        filters: payload.filters,
        filters_exist: payload.filters_exist,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_reasons_communication(filters: any): Promise<any> {
    const payload = filters;

    const { data } = await this.http_client.get(`${this.base_path}/clients/reasons-communication`, {
      params: {
        filters: payload.filters,
        filters_exist: payload.filters_exist,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_products(filters: any): Promise<any> {
    const payload = filters;

    const { data } = await this.http_client.get(`${this.base_path}/clients/products`, {
      params: {
        filters: payload.filters,
        filters_exist: payload.filters_exist,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_comments(filters: any): Promise<any> {
    const payload = filters;

    const { data } = await this.http_client.get(`${this.base_path}/clients/events-history`, {
      params: {
        filters: payload.filters,
        filters_exist: payload.filters_exist,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_devices(payload: any): Promise<any> {
    const { data } = await this.http_client.get(this.base_path, {
      params: payload,
    });

    return data;
  }

  async get_client(payload: { id: number, filters: Filters | null }) {
    const { data } = await this.http_client.get(
      `${this.base_path}/clients/${payload.id}`,
      { params: payload.filters },
    );

    return data;
  }

  async update_responsible_client(payload: any): Promise<any> {
    const { data } = await this.http_client.patch(
      `${this.base_path}/clients/${payload.id}/update-responsible`,
      payload,
    );

    return data;
  }

  async update_event(payload: any): Promise<any> {
    const { data } = await this.http_client.patch(
      `${this.base_path}/client-events/${payload.id}/reasons-communication`,
      payload,
    );

    return data;
  }

  async add_comment(payload: any): Promise<any> {
    const { data } = await this.http_client.post(
      `${this.base_path}/clients/${payload.client_id}/events-history`,
      payload,
    );

    return data;
  }

  async viewed(id: number) {
    const { data } = await this.http_client.patch(
      `${this.base_path}/clients/reasons-communication/${id}/viewed`,
    );

    return data;
  }

  async create_mark(payload: { name: string | null, client_id: number }) {
    const { data } = await this.http_client.post(
      `${this.base_path}/clients/${payload.client_id}/mark`,
      {
        name: payload.name,
      },
    );

    return data;
  }

  async delete_mark(payload: { id: number, client_id: number }) {
    const { data } = await this.http_client.delete(
      `${this.base_path}/clients/${payload.client_id}/mark/${payload.id}`,
    );

    return data;
  }

  async update_mass_client(payload: DataPilot.MassUpdateRequest): Promise<{ data: { count: number } }> {
    const { data } = await this.http_client.post(
      `${this.base_path}/clients/mass-update`,
      payload,
    );

    return data;
  }

  async update_mass_events(payload: DataPilot.MassUpdateRequest): Promise<{ data: { count: number } }> {
    const { data } = await this.http_client.post(
      `${this.base_path}/client-events/mass-update`,
      payload,
    );

    return data;
  }

  async get_count_clients(payload: DataPilot.MassUpdateFilters): Promise<{ data: { count: number } }> {
    const { data } = await this.http_client.post(
      `${this.base_path}/clients/mass-update/get-count-clients`,
      {
        filters: payload,
      },
    );

    return data;
  }

  async get_count_events(payload: DataPilot.MassUpdateFilters): Promise<{ data: { count: number } }> {
    const { data } = await this.http_client.post(
      `${this.base_path}/client-events/mass-update/get-count-events`,
      {
        filters: payload,
      },
    );

    return data;
  }
}

export const default_metrics = () => ({
  percentage_clients: 0,
  count_outlets: 0,
  count_devices: 0,
  events: [],
});

export const default_client = () => ({
  id: 0,
  name: '',
  name_organization: '',
  is_active: true,
  address: null,
  region: null,
  city: null,
  kpp: null,
  created_at: null,
  is_mark: null,
  is_resident: true,
  client_marks: [
    {
      id: 0,
      name: '',
    },
  ],
  client_excise_product_categories: [
    {
      id: 0,
      name: '',
    },
  ],
  client_product_categories: [
    {
      id: 0,
      name: '',
    },
  ],
  client_tax_systems: [
    {
      id: 0,
      name: '',
    },
  ],
  client_category: {
    id: 0,
    name: '',
  },
  okved: {
    id: 0,
    name: '',
  },
  contact: {
    email: null,
    telephone: null,
  },
  organization: {
    id: 0,
    name: '',
  },
  user: {
    id: 0,
    name: '',
  },
  client_status: {
    id: 0,
    name: '',
  },
  client_events: [
    {
      client_event_type: {
        id: 0,
        name: '',
        client_event_priority: {
          id: 0,
          color: '',
          name: '',
          sort: 0,
        },
      },
    },
  ],
});

export const default_clients_filters = () => ({
  search: '',
  tag_ids: [],
  event_status_ids: [],
  priority_ids: [],
  period: [],
  event_ids: [],
  client_status_ids: [],
  responsible_client_ids: [],
  responsible_event_ids: [],
  category_ids: [],
  mark_ids: [],
  client_id: null,
  display_all: true,
});

export const default_mass_change_filters = (): DataPilot.MassUpdateFilters => ({
  responsible_client_ids: [],
  mark_ids: [],
  cities: [],
  regions: [],
  okved_ids: [],
  client_category_ids: [],
  tax_system_ids: [],
  client_status_ids: [],
  product_category_ids: [],
  tag_ids: [],
  model_ids: [],

  event_status_ids: [],
  responsible_event_ids: [],
  event_ids: [],
  priority_ids: [],

  period: null,
  is_sign: null,
  is_excise: null,
});

export const serviceKKT = 'https://www.atol.ru/company/service-support/guarantee-policy/check/';

export const calculatorIts = 'https://www.atol.ru/catalog/pakety-uslug-its/calc_its/';

export const prefixConnect = 'https://ac.atol.ru/app/v2/cct/';

export const prefixSigma = 'https://manage.sigma.ru/client?id=';
